import React , { useState , useEffect , useContext } from "react";
import { Link , NavLink , useParams , useNavigate  } from "react-router-dom";
import Linechart from '../components/admin/chart/Linechart';
import Chart from "react-apexcharts";
import  { WebAssetsContext }  from "../App";


const  Productpricehistory = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const params = useParams();
  const [disabled, setDisabled] = useState(false);
  const [id, setId] = useState(params.id);
  const [name, setName] = useState("");

  const getProductDetails = async () => 
  {
    const res =  await fetch(api+"getProduct", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({id:id}),
          });
          let resJson = await res.json();
          return resJson;
  }

  

  const getProduct = async () => {
    try {
      const resJson = getProductDetails();
      resJson.then(function(output) {
        if(output.status === true)
        {
          setName(output.response.name);
        }
    });
    } catch (err) {
      console.log(err);
    }
  };
  const [productpricehistory, setProductpricehistory] = useState([]);
  const getProductPricehistory = async () => {
    try {
      const resJson = getProductPriceHistory();
      resJson.then(function(output) {
        if(output.status === true)
        {
          //setProductpricehistory(output.response.prices)
        }
    });
    } catch (err) {
      console.log(err);
    }
  };

  const getProductPriceHistory = async () => 
  {
    const res =  await fetch(api+"getProductPriceHistory", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({id:id}),
          });
          let resJson = await res.json();
          return resJson;
  }

  useEffect(() => {
    getProduct();
    getProductPricehistory();
  },[])

   
  return (
    <>
        
      <div className="section-body">
                  <div className="row">
                    <div className="col-12">
                        <div className="card">
                          
                            <div className="card-header">
                                <h4>{name}</h4>
                               
                                <div className="card-header-form">
                                      <button  onClick={() => navigate("/admin/products")} className="btn btn-icon icon-left btn-primary"><i className="fas fa-arrow-right"></i> Back</button>
                                </div>
                            </div>
                            
                          
                            <div className="card-body pl-4 pr-4 pt-0">
                              <Linechart id={params.id} height={400} />
                              { productpricehistory != '' ? 
                              <table className="table table-sm table-striped table-bordered">
                              <thead className="thead-dark1">
                                <tr>
                                    <th>Updated Date</th>
                                    <th>Price</th>
                                </tr>
                              </thead>
                              <tbody>
                              {productpricehistory.length > 0 ? productpricehistory.map((product , i)  => (
                                
                                <tr key={i}>
                                  <th scope="row">{props.changeDateFotmate(product.created_date , 'DD-MM-YYYY h:m:s a')}</th>
                                  <td>{props.currencySymbol()}{product.price}</td>
                                </tr>
                                ))  : 

                                <tr><td colSpan="10" className="text-center">Pricing history not found. </td></tr> 
                              }
                                
                              </tbody>
                              </table>
                              : ''}
                                 
                            </div>
                        </div>
                      </div>
                  </div>
                  </div>
    </>

  );
}

export default Productpricehistory;
